import jMoment from 'moment-jalaali';
import { REQUEST_STATUS } from '../../constants/consts';
import { Link as RouterLink } from 'react-router-dom';
import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Icons } from 'components';

const useStyles = makeStyles((theme) => ({
  expandBtn: {
    border: `1px solid #2b3990`,
    padding: theme.spacing(2),
    margin: 0,
    background: 'white',
    color: '#2b3990',
    '&:hover': {
      background: '#2b3990',
      color: '#fff',
    },
  },
}));

const columns = () => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'شناسه',
    field: 'id',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'تاریخ درخواست',
    field: 'requestDate',
    align: 'center',
    filtering: false,
    sorting: false,
    cellStyle: {
      width: '18%',
    },
    headerStyle: {
      width: '18%',
    },
    render: (rc) =>
      rc?.requestDate ? jMoment(rc?.requestDate).format('dddd, jD jMMMM jYYYY') : '-',
  },
  {
    title: 'تاریخ تعیین وضعیت',
    field: 'determineDate',
    align: 'center',
    filtering: false,
    sorting: false,
    cellStyle: {
      width: '18%',
    },
    headerStyle: {
      width: '18%',
    },
    render: (rc) =>
      rc?.determineDate ? jMoment(rc?.determineDate).format('dddd, jD jMMMM jYYYY') : '-',
  },
  {
    title: 'وضعیت',
    field: 'status',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '15%',
    },
    headerStyle: {
      width: '15%',
    },
    render: (rc) => REQUEST_STATUS?.find((v) => v?.value === rc?.status)?.label ?? '-',
  },
  {
    title: 'شرح',
    field: 'requesterDescription',
    filtering: false,
    sorting: false,
    render: (rc) =>
      rc?.requesterDescription
        ? rc?.requesterDescription?.length > 0
          ? rc?.requesterDescription
          : '-'
        : '-',
    headerStyle: {
      textAlign: 'right',
    },
    cellStyle: {
      overflowWrap: 'break-word',
      maxWidth: 10,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
  },
  {
    title: 'عملیات',
    field: 'operation',
    filtering: false,
    sorting: false,
    align: 'center',
    type: 'button',
    render: (row) => <SeeDetailBtn row={row} />,
  },
];

const columnsId = {
  invoiceId: '1349',
  tax: '1444',
  invoiceStatus: '1352',
  guildName: '1353',
  decreased: '1354',
  hasMultiInvoice: '1384',
};

const orderingIndexes = [
  null,
  'زمان شروع',
  'زمان انقضا',
  'نام و نام خانوادگی',
  'میزان',
  'استفاده شده',
  'تعداد شارژ مجدد',
  'وضعیت',
  null,
  null,
  null,
];

const generateData = (rows, query) => {
  const newData = rows.map((row, key) => {
    return {
      num: query?.page * query?.pageSize + key + 1,
      ...row,
    };
  });

  return newData;
};
const SeeDetailBtn = ({ row }) => {
  const classes = useStyles();

  return (
    <>
      {row?.canEdit && row?.status === 'BUSINESS_REQUEST_CONFIRMATION_REJECTED'? (
        <RouterLink to={`/RequestConfirmationEdit/${row?.id}`}>
          <Button
            startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />}
            variant="contained"
            className={classes.expandBtn}
          >
            ویرایش
          </Button>
        </RouterLink>
      ) : (
        <RouterLink to={`/RequestConfirmation/${row?.id}`}>
          <Button
            startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />}
            variant="contained"
            className={classes.expandBtn}
          >
            جزئیات
          </Button>
        </RouterLink>
      )}
    </>
  );
};

export { columns, columnsId, generateData, orderingIndexes };
